/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component } from '@angular/core';

@Component({
    templateUrl: './page-not-found.component.html'
})
export class PageNotFoundComponent {
    
}
